import Service from '@ember/service';

/**
 * This service is an interface. It is overridden by the actual service in embercom
 * when the composer loads within the app.
 */
export default Service.extend({
  currentConversation: 1
});